import ReactQuill from 'react-quill';
import { useEffect, useState } from 'react';
import './style.css';
import {
	IFunctionalGoals,
	IPlans,
	IPreExistingConditions,
} from '@stores/interfaces';

const toolbarOptions = [
	[{ font: [] }],
	[{ size: ['small', false, 'large', 'huge'] }],
	['bold', 'italic', 'underline', 'strike'],
	[{ color: [] }, { background: [] }],
	[{ align: [] }],
	[{ list: 'ordered' }, { list: 'bullet' }],
	['blockquote', 'link'],
	['clean'],
];

interface ImageInputCardProps {
	data: IPlans | IPreExistingConditions | IFunctionalGoals;
	onChange: (data: IPlans | IPreExistingConditions | IFunctionalGoals) => void;
}

export const ImageInputCard = ({ data, onChange }: ImageInputCardProps) => {
	const [title, setTitle] = useState(data?.title);
	const [description, setDescription] = useState(data?.description);
	const [image, setImage] = useState(data?.thumbnail);
	const [imageFile, setImageFile] = useState<File | null>();

	useEffect(() => {
		onChange({ ...data, title: title });
	}, [title]);

	useEffect(() => {
		onChange({ ...data, description: description });
	}, [description]);

	useEffect(() => {
		onChange({ ...data, imageFile: imageFile! });
	}, [imageFile]);

	useEffect(() => {
		if(data?.description != description) setDescription(data?.description)
		if(data?.title != title) setTitle(data?.title)
		if(data?.thumbnail != image && !imageFile?.name) setImage(data?.thumbnail)
	}, [data])

	const handleDescriptionChange = (content: string) => {
		setDescription(content)
	}

	const handleImageChange = (file: File) => {
		const imageUrl = URL.createObjectURL(file);
		setImageFile(file);
		setImage(imageUrl);
	};

	return (
		<div className="image-input-card-container">
			<div className="image-input-card-upload-wrapper">
				<label className="image-input-card-label">
					<img
						src={(imageFile?.name ? image : data.thumbnail) || image}
						alt={data.title}
						className="image-input-card-image"
					/>
					<input
						type="file"
						accept="image/*"
						style={{ display: 'none' }}
						onChange={e =>
							e.target.files?.[0] && handleImageChange(e.target.files[0])
						}
					/>
					<div className="image-input-card-overlay">Change</div>
				</label>
			</div>

			<div className="image-input-card-form">
				<input
					className="image-input-card-title-input"
					value={data.title}
					onChange={e => setTitle(e.target.value)}
					placeholder="Enter title"
				/>
				<ReactQuill
					value={description}
					onChange={handleDescriptionChange}
					modules={{ toolbar: toolbarOptions }}
					theme="snow"
					className="image-input-card-quill"
				/>
			</div>
		</div>
	);
};
